import { render } from "./VendorOrdersShowCardItemsTable.vue?vue&type=template&id=55f6e16a"
import script from "./VendorOrdersShowCardItemsTable.vue?vue&type=script&lang=js"
export * from "./VendorOrdersShowCardItemsTable.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__